export interface ProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function Progress(props: ProgressProps) {
  const percentageFromRight =
    ((props.totalSteps - props.currentStep) / props.totalSteps) * 100;

  return (
    <div className="relative h-10 w-[327px]">
      <div className="absolute inset-x-0 bottom-0 top-[80%] rounded-lg bg-[rgba(242,110,96,1)] opacity-10" />
      <div
        style={{
          right: `${percentageFromRight}%`,
        }}
        className="absolute left-0 bottom-0 top-[80%] rounded-lg bg-[rgba(242,110,96,1)]"
      />
      <p className="absolute top-0 bottom-[40%] left-[calc(50%_-_20.5px_+_0px)] inline text-right font-['Rubik'] text-base font-medium leading-[1.5] text-[rgba(242,110,96,1)]">
        {props.currentStep} of {props.totalSteps}
      </p>
    </div>
  );
}
